// extracted by mini-css-extract-plugin
export default {"questionCardContainer":"DetailQuestion_questionCardContainer__0GMgP","uncheckedOption":"DetailQuestion_uncheckedOption__iiQb9","checkedOption":"DetailQuestion_checkedOption__I2AUE"};